import { Pagination, Table } from "antd";
import moment from "moment";

window.Buffer = window.Buffer || require("buffer").Buffer;

function DataTable(props) {
  // Helper function to get latest box status
  const getLatestBoxStatus = (record) => {
    if (record?.boxStatus && Array?.isArray(record?.boxStatus)) {
      // Sort by created_at descending and get the latest
      const sortedStatus = record?.boxStatus?.sort(
        (a, b) =>
          moment(b?.created_at).valueOf() - moment(a?.created_at).valueOf()
      );
      return sortedStatus[0];
    }
    return null;
  };

  // Helper function to calculate delay days between today and booking date
  const calculateDelayDaysFromBooking = (bookingDate) => {
    if (!bookingDate) return 0;
    const today = moment().startOf("day");
    const booking = moment(bookingDate).startOf("day");
    return today.diff(booking, "days");
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) =>
        (props.meta.page - 1) * props.meta.take + index + 1,
    },

    {
      title: <div style={{ fontSize: "11.8px" }}>Booking ID</div>,
      dataIndex: "collection_id",
      key: "collection_id",
      width: "10%",
      sortDirections: ["descend", "ascend"],
    },

    {
      title: <div style={{ fontSize: "11.8px" }}>Box Number</div>,
      dataIndex: "box_number",
      key: "box_number",
      width: "10%",
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "Size",
      dataIndex: "boxType",
      key: "size",
      render: (text, record, index) => (
        <div className="boxes-table-item">
          {record?.boxType?.name ? record.boxType.name.toUpperCase() : "-"}
        </div>
      ),
    },

    {
      title: "Weight",
      dataIndex: "chargable_weight",
      key: "chargable_weight",
      render: (text, record, index) => <div>{text}</div>,
    },

    {
      title: "Service",
      dataIndex: "service_type",
      key: "service_type",
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => (
        <div className="boxes-table-item">{record?.service?.name || "-"}</div>
      ),
    },

    {
      title: "Booking Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => <div>{moment(text).format("DD-MM-YYYY")}</div>,
    },

    {
      title: "Receive Date",
      dataIndex: "box_status",
      key: "receive_date",
      render: (text, record) => {
        const latestStatus = getLatestBoxStatus(record);
        return (
          <div>
            {latestStatus && latestStatus?.created_at
              ? moment(latestStatus?.created_at).format("DD-MM-YYYY")
              : ""}
          </div>
        );
      },
    },

    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text, record, index) => (
        <div className="boxes-table-item">
          {record?.created_user?.name
            ? record.created_user.name.toUpperCase()
            : "-"}
        </div>
      ),
    },
    {
      title: "Delay Days",
      dataIndex: "delay_days",
      key: "delay_days",
      render: (text, record) => {
        const bookingDate = record?.createdAt;
        const delayDays = calculateDelayDaysFromBooking(bookingDate);
        return (
          <div
            style={{
              color: delayDays > 0 ? "#ff4d4f" : "#52c41a",
              fontWeight: delayDays > 0 ? "bold" : "normal",
            }}
          >
            {delayDays > 0 ? `${delayDays} days` : "0 days"}
          </div>
        );
      },
    },
    // {
    //   title: "Branch",
    //   dataIndex: "branch",
    //   key: "branch",
    //   render: (text, record, index) => (
    //     <div className="boxes-table-item">
    //       {record?.branchs?.name ? record.branchs.name.toUpperCase() : "-"}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Country",
    //   dataIndex: "country",
    //   key: "country",
    //   render: (text, record, index) => (
    //     <div className="boxes-table-item">
    //       {record?.created_user?.countries?.name
    //         ? record.created_user.countries.name.toUpperCase()
    //         : "-"}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Stock Status",
    //   dataIndex: "is_stock",
    //   key: "is_stock",
    //   render: (text, record, index) => (
    //     <div className="boxes-table-item">
    //       <span
    //         style={{
    //           padding: "4px 8px",
    //           borderRadius: "4px",
    //           fontSize: "12px",
    //           fontWeight: "500",
    //           backgroundColor: record?.is_stock ? "#f6ffed" : "#fff2f0",
    //           color: record?.is_stock ? "#52c41a" : "#ff4d4f",
    //           border: `1px solid ${record?.is_stock ? "#b7eb8f" : "#ffccc7"}`,
    //         }}
    //       >
    //         {record?.is_stock ? "In Stock" : "Out of Stock"}
    //       </span>
    //     </div>
    //   ),
    // },
  ];

  // Calculate total weight for all data (not just current page)
  const totalWeight = props.fullData
    ? props.fullData.reduce(
        (sum, item) => sum + (parseFloat(item.chargable_weight) || 0),
        0
      )
    : props.data.reduce(
        (sum, item) => sum + (parseFloat(item.chargable_weight) || 0),
        0
      );

  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        columns={columns}
        dataSource={props?.data || []}
        pagination={false}
        // scroll={{ x: true }}
        size="small"
        summary={() => (
          <Table.Summary.Row
            style={{
              backgroundColor: "#d3d3d3ff",
              fontWeight: "bold",
            }}
          >
            <Table.Summary.Cell index={0} colSpan={5} />
            <Table.Summary.Cell index={1} colSpan={5}>
              <strong>Total Weight : {totalWeight.toFixed(2)} Kg</strong>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />
      <div align="right">
        <Pagination
          defaultCurrent={props.meta && props.meta.page}
          total={props.meta && props.meta.itemCount}
          pageSize={props.meta && props.meta.take ? props.meta.take : 0}
          onChange={props.PageOnchange}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
}
export default DataTable;
